import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import InfoBlock from '@components/common/info_block';

const DeleteApiKeyModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'delete_account'
    });

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                Delete API key
            </Typography>
            <Typography variant="body2" alignment="center">
                Are you sure you want to delete this API key? It will be permanently removed.
            </Typography>
            <InfoBlock variant="error">
                Please note: Deleting the key will immediately revoke access. Any API requests made
                using it will be rejected, and all webhooks associated with this key will be
                deleted, which could cause systems still relying on them to stop working.
            </InfoBlock>
        </div>
    );
};

export default DeleteApiKeyModal;
